import ChatBodyFooter from "./ChatBodyFooter";

export default ChatBodyFooter;
